import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const avgOutboundClicksPerPinConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.pinterest.avg_outbound_clicks_per_pin',
    id: 'average_outbound_clicks_per_pin',
    icon: {
        name: 'click',
        style: colors.blue
    },
    tooltip: 'kpi.pinterest.tooltip_avg_outbound_clicks_per_pin',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
